import { useEffect, useState } from "react";
import { Car, Flower2, Gift, Rocket, Trophy, RotateCcw } from "lucide-react";

const TEAMS = [
  { key: "a", name: "Qırmızı", color: "#F43F5E" },
  { key: "b", name: "Mavi", color: "#3B82F6" },
  { key: "c", name: "Yaşıl", color: "#10B981" },
];
export const GIFTS = [
  { key: "rose", name: "Rose", effect: "Maşın +3", add: 3, Icon: Flower2, cls: "text-rose-400" },
  { key: "box", name: "Gift", effect: "Maşın +12", add: 12, Icon: Gift, cls: "text-amber-300" },
  { key: "universe", name: "Universe", effect: "Boost +30", add: 30, Icon: Rocket, cls: "text-[#F3D592]" },
];
const VIEWERS = ["aysel_22", "elvin.az", "murad_live", "nigar.b", "tural07"];
const START = { a: 0, b: 0, c: 0 };

export const RaceDemo = () => {
  const [pos, setPos] = useState(START);
  const [team, setTeam] = useState("b");
  const [feed, setFeed] = useState([]);
  const winner = TEAMS.find((t) => pos[t.key] >= 100);

  useEffect(() => {
    if (winner) return;
    const id = setInterval(() => {
      const t = TEAMS[Math.floor(Math.random() * 3)].key;
      setPos((p) => ({ ...p, [t]: Math.min(100, p[t] + 1) }));
    }, 900);
    return () => clearInterval(id);
  }, [winner]);

  const send = (g) => {
    if (winner) return;
    setPos((p) => ({ ...p, [team]: Math.min(100, p[team] + g.add) }));
    const who = VIEWERS[Math.floor(Math.random() * VIEWERS.length)];
    const tName = TEAMS.find((t) => t.key === team).name;
    setFeed((f) => [{ id: Date.now(), text: `${who} → ${g.name} (${tName}: ${g.effect})` }, ...f].slice(0, 3));
  };

  return (
    <div data-testid="race-demo">
      <div className="space-y-2 rounded-xl bg-[#111110] border border-white/10 p-3">
        {TEAMS.map((t) => (
          <div key={t.key} className="relative h-11 rounded-lg bg-white/[0.03] border-r-4 border-dashed border-white/40 overflow-hidden">
            <div className="absolute inset-y-0 left-0 opacity-20" style={{ width: `${pos[t.key]}%`, background: t.color, transition: "width .4s ease" }} />
            <div className="absolute top-1/2 -translate-y-1/2" style={{ left: `calc(${pos[t.key]}% - ${pos[t.key] * 0.32}px)`, transition: "left .4s ease" }}>
              <Car className="h-8 w-8" style={{ color: t.color }} />
            </div>
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-mono text-[#a9a398]" data-testid={`race-pos-${t.key}`}>{pos[t.key]}%</span>
          </div>
        ))}
      </div>

      {winner ? (
        <div className="mt-4 text-center" data-testid="race-winner">
          <Trophy className="h-10 w-10 mx-auto text-amber-300" />
          <div className="font-display text-xl font-bold mt-2">{winner.name} komanda qalib gəldi!</div>
          <button className="adv-btn-ghost mt-3 text-sm" onClick={() => { setPos(START); setFeed([]); }} data-testid="race-reset">
            <RotateCcw className="h-4 w-4" /> Yenidən
          </button>
        </div>
      ) : (
        <>
          <div className="flex gap-2 mt-4">
            {TEAMS.map((t) => (
              <button key={t.key} onClick={() => setTeam(t.key)} data-active={team === t.key} data-testid={`race-team-${t.key}`} className="adv-option flex-1 py-2 text-sm font-medium flex items-center justify-center gap-2">
                <span className="h-3 w-3 rounded-full" style={{ background: t.color }} /> {t.name}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2 mt-3">
            {GIFTS.map((g) => (
              <button key={g.key} onClick={() => send(g)} data-testid={`tiktok-gift-${g.key}`} className="adv-option py-3 flex flex-col items-center gap-1 hover:bg-white/5">
                <g.Icon className={`h-7 w-7 ${g.cls}`} />
                <span className="text-sm font-semibold">{g.name}</span>
                <span className="text-[11px] text-[#a9a398] font-mono">→ {g.effect}</span>
              </button>
            ))}
          </div>
        </>
      )}
      <div className="mt-3 space-y-1 min-h-[60px]" data-testid="race-feed">
        {feed.map((f) => <div key={f.id} className="text-xs text-[#a9a398] font-mono">{f.text}</div>)}
      </div>
    </div>
  );
};
